export const AUTHENTICATED_USER_FEATURE_KEY = 'authenticated';
